/* hanzo.lt: Kaching cart progress bar — truthful two-milestone text.
   Milestones (2026-09-24): 120 EUR = nemokamas pristatymas, 140 EUR = slapta dovana.
   Kaching's {{progress_needed}} counts to the NEXT milestone and wraps the
   amount in invisible bidi isolate chars (U+2066..U+2069).
   States:
   - nothing unlocked (<120): shown X = to shipping; gift = X + GAP.
   - shipping unlocked (120-140, text contains "priklauso"): shown X = to gift.
   IF THE THRESHOLDS CHANGE IN KACHING, UPDATE GAP AND THE SENTENCES BELOW. */
(function () {
  'use strict';
  if (!location.hostname.includes('hanzo.lt')) return;
  var GAP = 20; // see header
  var GIFT_VARIANT_ID = 53734331482455; // "Slapta dovana" auto-gift (SP pan deal)
  var giftInCart = false;
  function pollCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        giftInCart = c.items.some(function (i) { return i.variant_id === GIFT_VARIANT_ID; });
      })
      .catch(function () {});
  }

  function fmt(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function clean(s) { return (s || '').replace(/[⁦-⁩‎‏]/g, ''); }

  function allRoots(root, acc) {
    acc.push(root);
    var els = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) allRoots(els[i].shadowRoot, acc);
    }
    return acc;
  }

  var RX = /trūksta\s*([\d\s.,]+?)\s*€/;

  function fix() {
    var roots = allRoots(document, []);
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];
      var els = root.querySelectorAll ? root.querySelectorAll('p,div,span') : [];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') continue;
        var t = clean(el.textContent).replace(/\s+/g, ' ');
        if (t.length > 260) continue;
        var m = t.match(RX);
        if (!m) continue;
        var childHas = false;
        for (var c = 0; c < el.children.length; c++) {
          if (RX.test(clean(el.children[c].textContent))) { childHas = true; break; }
        }
        if (childHas) continue;
        var x = parseFloat(m[1].replace(/\s/g, '').replace(',', '.'));
        if (!isFinite(x)) continue;
        var mark = String(x) + ':' + (giftInCart ? 'g' : 'n');
        if (el.getAttribute('data-hzfix') === mark) continue;
        var unlocked = t.indexOf('priklauso') !== -1;
        if (giftInCart) {
          /* the SP-pan deal already put the secret gift in the cart */
          if (unlocked) {
            el.innerHTML = 'Jums priklauso <b>Nemokamas pristatymas</b> 🚚 Slapta dovana – jau Jūsų krepšelyje! 🎁';
          } else {
            el.innerHTML = 'Jums trūksta <b>' + fmt(x) + '</b> iki nemokamo pristatymo! 🚚';
          }
        } else if (unlocked) {
          /* shipping unlocked: X counts to the gift milestone */
          el.innerHTML = 'Jums priklauso <b>Nemokamas pristatymas</b> 🚚 Iki slaptos dovanos trūksta <b>' + fmt(x) + '</b>! 🎁';
        } else {
          /* nothing unlocked: X counts to shipping; gift is GAP further */
          el.innerHTML = 'Jums trūksta <b>' + fmt(x) + '</b> iki nemokamo pristatymo ir <b>' + fmt(x + GAP) + '</b> iki slaptos dovanos! 🎁';
        }
        el.setAttribute('data-hzfix', mark);
      }
    }
  }

  function fillBars() {
    /* all rewards effectively earned (gift in cart + shipping unlocked):
       make the Kaching progress bar read as complete */
    if (!giftInCart) return;
    var roots = allRoots(document, []);
    for (var r = 0; r < roots.length; r++) {
      var bars = roots[r].querySelectorAll ? roots[r].querySelectorAll('.kaching-cart__tiered-promotions-bar') : [];
      for (var b = 0; b < bars.length; b++) {
        var bar = bars[b];
        if (clean(bar.textContent).indexOf('priklauso') === -1) continue;
        var fill = bar.querySelector('.kaching-cart__tiered-promotions-bar-progress-fill');
        if (!fill) continue;
        if (fill.style.width !== '100%') fill.style.width = '100%';
        var green = getComputedStyle(fill).backgroundColor;
        var circles = bar.querySelectorAll('.kaching-cart__tiered-promotions-bar-icon svg circle');
        for (var c = 0; c < circles.length; c++) {
          var f = circles[c].getAttribute('fill');
          if (f && f.indexOf('191') !== -1) circles[c].setAttribute('fill', green);
          var st = circles[c].getAttribute('stroke');
          if (st && st.indexOf('191') !== -1) circles[c].setAttribute('stroke', green);
        }
        var titles = bar.querySelectorAll('.kaching-cart__tiered-promotions-bar-icon-tooltip-title');
        for (var ti = 0; ti < titles.length; ti++) {
          if ((titles[ti].style.color || '').indexOf('191') !== -1) titles[ti].style.color = green;
        }
      }
    }
  }

  function start() { pollCart(); setInterval(pollCart, 2500); setInterval(fix, 600); setInterval(fillBars, 600); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
